import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-00e22cf4"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "dropdown-prompt" };
const _hoisted_2 = {
    key: 1,
    class: "form form--multiselect"
};
const _hoisted_3 = {
    key: 2,
    class: "list list--drop-down"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "footer" };
import _ from "underscore";
import { ref, computed, nextTick } from "vue";
import { onClickOutside } from "@vueuse/core";
import { ElButton } from "element-plus";
import Strings from "src/shared/Strings";
import { useFuzzySearch } from "src/shared/store/common/fuzzy-search";
export default /*#__PURE__*/ _defineComponent({
    __name: 'MultiSelectDropDownInput',
    props: {
        options: {},
        prompt: {},
        value: {}
    },
    emits: ["update:value"],
    setup(__props, { emit: __emit }) {
        const isSelectShown = ref(false);
        const props = __props;
        const emit = __emit;
        const dropdown = ref(null);
        const searchQuery = ref("");
        const input = ref(null);
        const filteredOptions = computed(() => {
            return useFuzzySearch(searchQuery, props.options, [
                "displayName",
                "value",
            ]).value.filter((option) => option.displayName !== undefined);
        });
        const selectedOptionsProxy = computed({
            get() {
                return props.value;
            },
            set(value) {
                emit("update:value", value);
            },
        });
        const allOptionsSelected = computed(() => {
            if (!props.options) {
                return false;
            }
            const parsedOptions = _.map(props.options, (option) => option.value);
            return parsedOptions.every((option) => selectedOptionsProxy.value.includes(option));
        });
        const selectItem = (value) => {
            const index = selectedOptionsProxy.value.indexOf(value);
            if (index === -1) {
                selectedOptionsProxy.value = [...selectedOptionsProxy.value, value];
            }
            else {
                selectedOptionsProxy.value = selectedOptionsProxy.value.filter((item) => item !== value);
            }
            searchQuery.value = "";
        };
        onClickOutside(dropdown, () => {
            isSelectShown.value = false;
        });
        const showSelect = () => {
            isSelectShown.value = true;
            nextTick(() => {
                var _a;
                (_a = input.value) === null || _a === void 0 ? void 0 : _a.focus();
            });
        };
        const selectAll = () => {
            if (!props.options) {
                return;
            }
            selectedOptionsProxy.value = filteredOptions.value.map((item) => item.value);
        };
        const clearAll = () => {
            selectedOptionsProxy.value = [];
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "drop-down--multiselect",
                ref_key: "dropdown",
                ref: dropdown
            }, [
                (!isSelectShown.value)
                    ? (_openBlock(), _createBlock(_unref(ElButton), {
                        key: 0,
                        onClick: showSelect,
                        class: _normalizeClass(["button button--tertiary button--drop-down list--drop-down--modern", {
                                active: _ctx.options && _ctx.options.length > 1 && isSelectShown.value,
                            }])
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.prompt), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["class"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _withDirectives(_createElementVNode("input", {
                            type: "text",
                            placeholder: "Search",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((searchQuery).value = $event)),
                            onFocus: _cache[1] || (_cache[1] = ($event) => (isSelectShown.value = true)),
                            ref_key: "input",
                            ref: input
                        }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                            [_vModelText, searchQuery.value]
                        ])
                    ])),
                (isSelectShown.value)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredOptions.value, (option) => {
                            return (_openBlock(), _createElementBlock("li", {
                                class: _normalizeClass({
                                    active: selectedOptionsProxy.value.some((item) => item === option.value),
                                }),
                                key: option.displayName,
                                onClick: ($event) => (selectItem(option.value))
                            }, [
                                _createElementVNode("a", null, _toDisplayString(_unref(Strings).capitalize(option.displayName)), 1 /* TEXT */)
                            ], 10 /* CLASS, PROPS */, _hoisted_4));
                        }), 128 /* KEYED_FRAGMENT */)),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("a", {
                                onClick: _withModifiers(selectAll, ["prevent"]),
                                class: _normalizeClass({
                                    disabled: allOptionsSelected.value,
                                })
                            }, "Select All", 2 /* CLASS */),
                            _createElementVNode("a", {
                                onClick: _withModifiers(clearAll, ["prevent"]),
                                class: _normalizeClass({
                                    disabled: !allOptionsSelected.value,
                                })
                            }, "Clear All", 2 /* CLASS */)
                        ])
                    ]))
                    : _createCommentVNode("v-if", true)
            ], 512 /* NEED_PATCH */));
        };
    }
});
